import type { CountryEntry, CountryModel } from 'types';

export const getCountriesMap = (countries: Array<CountryEntry>) => countries.reduce((obj, item) => {
  obj[item.country.toLowerCase()] = item.countryCode; // eslint-disable-line no-param-reassign
  return obj;
}, {});

export const getTransformedCountries = (countries: Array<CountryModel>) => countries.map<CountryEntry>(country => ({
  country: country.niceName,
  countryCode: country.iso,
  phoneCode: country.phoneCode
}));
